import React, { useState } from "react";
import { useLoginStyles } from "../login/styles";
import {
  Button,
  Card,
  CardHeader,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  Spinner,
  Text,
} from "@fluentui/react-components";
import { Dismiss24Regular, PersonRegular } from "@fluentui/react-icons";
import { forgotPassword } from "@/services/auth-service";
import { AxiosError } from "axios";
import { useRoute } from "@/context/router";
import { useForgotPasswordStyles } from "./styles";
import log from "../../utils/logger";
import { YellowPadLogo } from "@/components/yellowpad-logo";

export const ForgotPassword = () => {
  const loginStyles = useLoginStyles();
  const styles = useForgotPasswordStyles();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>(null);
  const [emailSentDialogOpen, setEmailSentDialogOpen] = useState(false);
  const { setCurrentRoute } = useRoute();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      setError(null);
      await forgotPassword(email);
      setEmailSentDialogOpen(true);
    } catch (error) {
      log.error("Forgot password error", undefined, error);
      if (error instanceof AxiosError) {
        setError(error.response?.data || error.message || "Failed to forgot password.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={loginStyles.container}>
      <Card className={loginStyles.card}>
        <CardHeader
          header={
            <div className={loginStyles.header}>
              <YellowPadLogo width={32} height={32} />
              <Text weight="semibold" size={500}>
                Forgot Password
              </Text>
            </div>
          }
        />
        <form className={loginStyles.form} onSubmit={handleSubmit}>
          <Field required label="Email">
            <Input
              required
              id="email"
              value={email}
              className={loginStyles.input}
              contentBefore={<PersonRegular className={loginStyles.icon} />}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Button
            iconPosition="after"
            disabled={loading}
            type="submit"
            appearance="primary"
            className={loginStyles.button}
          >
            Forgot Password
            {loading && <Spinner size="extra-tiny" className={loginStyles.loading} />}
          </Button>
          <Button onClick={() => setCurrentRoute("login")} appearance="secondary" className={loginStyles.button}>
            Back to Login
          </Button>
          {error && <div className={loginStyles.errorText}>{error}</div>}
        </form>
      </Card>

      <Dialog open={emailSentDialogOpen} onOpenChange={(_, data) => setEmailSentDialogOpen(data.open)}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle className={styles.dialogTitle}>
              <span>Instructions sent</span>
              <Button icon={<Dismiss24Regular />} onClick={() => setEmailSentDialogOpen(false)} aria-label="Close" />
            </DialogTitle>
            <DialogContent>
              <div>
                <Text>
                  If the email is in our system, we sent instructions to change your password to {email}. Please check
                  both your inbox and spam folder.
                </Text>
              </div>
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
};
